import * as ng from 'angular';
import * as _ from 'underscore';
import * as uir from '@uirouter/angularjs';
import * as uib from 'angular-ui-bootstrap';

import { SessionService } from '../../shared';
import { CampaignsApi } from './campaigns-api.service';

export class CampaignEditController {
   static $inject = [
      '$window', '$state', '$stateParams', '$uibModal', 'session',
      'campaignsApi', 'experiencesService', 'dialogs', 'toast', 'loader',
      'localStorageService', 'titleService', 'tinymceOptions'
   ];

   constructor(
      private $window:ng.IWindowService,
      private $state:uir.StateService,
      $stateParams:uir.StateParams,
      private $uibModal:uib.IModalService,
      private session:SessionService,
      private campaignsApi:CampaignsApi,
      experiencesService,
      private dialogs,
      private toast,
      private loader,
      private localStorageService,
      titleService,
      public tinymceOptions
   ) {
      titleService.setTitle('Campaign Details');

      let brand = $stateParams.brand? $stateParams.brand : this.session.getBrand();
      let org = $stateParams.org? $stateParams.org : this.session.getOrg();

      let brandSettings = brand.settings;

      // allows for selecting alternate initial tab on state change
      this.activeTab = $stateParams.tab;
      this.enableAnonymizationInviteeProspects = false;
      this.enableAnonymizationPreRegParticipants = false;

      if ($state.current.name == 'campaign.add') {
         this.isCreate = true;

         this.model = {
            brandId: brand.id,
            settings: {
               defaultLanguage: 'en',
               languages: ['en'],
               unsubscribeUrl: brandSettings.unsubscribeUrl,
               experienceFooterText: brandSettings.experience.footerText,
               emailExperienceFooterText: brandSettings.experience.emailFooterText,
               facebookLink: brandSettings.facebookLink,
               twitterLink: brandSettings.twitterLink,
               instagramLink: brandSettings.instagramLink,
               anonymization: brandSettings.anonymization ?? {},
               dashboard: this.defaultDashboardState
            }
         };

         this.language = this.model.settings.defaultLanguage;
         this.enableAnonymizationInviteeProspects = this.model.settings.anonymization.anonDaysInviteeProspects > 0;
         this.enableAnonymizationPreRegParticipants = this.model.settings.anonymization.anonDaysPreRegParticipants > 0;      
      } else {
         this.isCreate = false;
         loader.showSpinner();

         let campaignId = $stateParams.id? $stateParams.id : this.session.getCampaign().id;

         campaignsApi.get(campaignId)
            .then((campaign) => {
               this.model = campaign;
               this.language = this.model.settings.defaultLanguage;
               this.campaignLanguages = ng.copy(this.model.settings.languages);

               if (this.model.settings.anonymization != null) {
                  this.enableAnonymizationInviteeProspects = this.model.settings.anonymization.anonDaysInviteeProspects > 0;
                  this.enableAnonymizationPreRegParticipants = this.model.settings.anonymization.anonDaysPreRegParticipants > 0;
               } else {
                  this.model.settings.anonymization = {};
               }

               // if the dashboard has not been customized, we enable all widgets by default
               if (!this.model.settings.dashboard || this.model.settings.dashboard == null) {
                  this.model.settings.dashboard = this.defaultDashboardState;
               }

               if (localStorageService.get('youtube-authorize')) {
                  localStorageService.remove('youtube-authorize');

                  if ($stateParams.youtube_deny) {
                     toast
                        .error()
                        .message('YouTube connection denied')
                        .send();
                  } else if (!this.model.settings.youTubeRefreshToken) {
                     this.disconnectYouTube(true);
                  }
               }

               return experiencesService.list(this.model.id);
            }).then((experiences:any[]) => {
               this.hasExperiences = experiences.length > 0;
            }).finally(() => loader.hide());
      }

      this.org = org;
      this.brand = brand;
      this.campaign = this.session.getCampaign();

      if (this.isBrownFormanOrg && this.isCreate) {
         this.model.ageRequirementType = 'spirit'
      }
   }

   get gates() {
      if (this.isBrownFormanOrg) {
         return {
            'spirit': 'Spirits (non-wine)',
            'wine': 'Wine / Beer',
            'other': 'Other'
         };
      } else {
         return {
            'auto': 'Driving',
            'spirit': 'Spirits (non-wine)',
            'wine': 'Wine / Beer',
            'other': 'Other'
         };
      }
   }

   readonly fcaSubSources = {
      'ATS': 'Autoshow',
      'BCN': 'Business Center',
      'CME': 'Community Events',
      'CMR': 'Commercial Events',
      'MPR': 'Mopar',
      'AFL': 'Affiliate Rewards',
      'MSP': 'Motor Sports'
   };

   readonly defaultDashboardState = {
      goals: true,
      mediaTotals: {
         useAlternate: false,
         backgroundColor: '#39329c',
         color: '#ffffff',
         name: 'Media Totals'
      },
      guestTotals: {
         useAlternate: false,
         backgroundColor: '#3cb4e5',
         color: '#ffffff',
         name: 'Guest Totals'
      },
      completedEvents: {
         useAlternate: false,
         backgroundColor: '#e353a9',
         color: '#ffffff',
         name: 'Completed Events'
      },
      participantMap: {
         useAlternate: false,
         name: 'Participants Map',
         type: 'chart',
      },
      optInFunnel: {
         useAlternate: false,
         name: 'Opt-In Funnel',
         type: 'chart'
      },
      currentUpcomingEvents: {
         useAlternate: false,
         name: 'Current & Upcoming Events',
         type: 'chart'
      }
   }

   reset() {
     this.model.settings.dashboard = this.defaultDashboardState;
   }

   editDashboardWidget(key, value) {
      this.$uibModal.open({
         component: 'dashboardCustomizationEditor',
         resolve: {
            dashboardWidget: () => value
         }
      }).result.then(result => {
         this.model.settings.dashboard[key] = result;
      });
   }

   private hasExperiences = false;
   private campaignLanguages:string[];

   isCreate:boolean;
   model;

   language:string;

   org;
   brand;
   campaign;

   activeTab:number;
   enableAnonymizationInviteeProspects:boolean;
   enableAnonymizationPreRegParticipants:boolean;

   get isBrownFormanOrg() {
      return this.org.slug.indexOf('brown-forman') >= 0;
   }

   canEditAgeGate() {
      if (this.isBrownFormanOrg) {
         return (this.session.getUser().isSuperAdmin || this.session.getUser().isOrgAdmin)
      } else {
         return true;
      }
   }

   toggleAnonymizationInviteeProspects() {
      if (this.enableAnonymizationInviteeProspects) {
         this.model.settings.anonymization.anonDaysInviteeProspects = this.brand.settings.anonymization?.anonDaysInviteeProspects ?? 30;
      } else {
         this.model.settings.anonymization.anonDaysInviteeProspects = null;
      }
   }

   toggleAnonymizatioPreRegParticipants() {
      if (this.enableAnonymizationPreRegParticipants) {
         this.model.settings.anonymization.anonOmitOptins = this.brand.settings.anonymization?.anonOmitOptins ?? false;
         this.model.settings.anonymization.anonDaysPreRegParticipants = this.brand.settings.anonymization?.anonDaysPreRegParticipants ?? 30;
         this.model.settings.anonymization.anonAfterEventEnd = this.brand.settings.anonymization?.anonAfterEventEnd ?? true;
      } else {
         this.model.settings.anonymization.anonOmitOptins = false;
         this.model.settings.anonymization.anonDaysPreRegParticipants = null;
         this.model.settings.anonymization.anonAfterEventEnd = null;
      }
   }

   private authorizeYouTube(url:string) {
      this.localStorageService.set('youtube-authorize', true);
      this.$window.location.href = url;
   }

   back() {
      this.$window.history.back();
   }

   save(form:ng.IFormController) {
      if (this.model.ageRequirementType !== 'other') {
         // just incase user entered invalid value, then change to type != other
         // invalid value would cause invisible validation error
         this.model.settings.minAgeOther = null;
      }

      if (this.isCreate) {
         this.loader.showSpinner();
         this.campaignsApi.create(this.model).then(campaign => {
            return this.session.refreshUser({orgId:this.org.id, brandId:this.brand.id, campaignId: campaign.id});
         }).then(() => {
            this.toast
               .success()
               .message('Campaign created successfully')
               .send();

            this.$state.go('campaign.edit');
         }).finally(() => this.loader.hide());
      } else {
         let doUpdate = () => {
            this.loader.showSpinner();
            return this.campaignsApi.update(this.model).then(campaign => {
               this.model = campaign;
               this.campaignLanguages = ng.copy(campaign.settings.languages);
               return this.session.refreshUser({orgId:this.org.id, brandId:this.brand.id, campaignId: campaign.id});
            }).then(() => {
               this.toast
                  .success()
                  .message('Campaign updated successfully')
                  .send();
            }).finally(() => this.loader.hide());
         };

         if (this.hasExperiences
            && !_.isEqual(this.campaignLanguages, this.model.settings.languages)
         ) {
            this.dialogs.confirm('You already have saved experiences in this campaign. To add or remove languages in these ' +
               'existing experiences, you will need to manually save each experience.')
               .then(doUpdate);
         } else {
            doUpdate();
         }
      }
   }

   del() {
      this.dialogs.confirm('Are you sure you want to delete this campaign?').then(() => {
         this.loader.showSpinner();
         this.campaignsApi.del(this.model.id)
            .then(() => this.onDeleteSuccess())
            .catch(resp => this.onDeleteFailed(resp))
            .finally(() => this.loader.hide());
      });
   }

   private onDeleteSuccess() {
      this.toast.message(`Campaign "${this.model.name}" was deleted`).send();
      return this.session.refreshUser({orgId:this.org.id, brandId:this.brand.id})
         .then(() => this.$state.reload());
   }

   private onDeleteFailed(resp) {
      let message:string;
      if (resp.status == 409) {
         message = `Campaign has ${resp.data.eventCount} events associated with it and could not be deleted.`
      } else {
         return resp;
      }

      if (this.session.isAdmin()) {
         message = message + " Press OK if you're sure you would like to delete this campaign and all associated events.";
         return this.dialogs.delete(message)
            .then(() => this.campaignsApi.del(this.model.id, true))
            .then(() => this.onDeleteSuccess());
      } else {
         return this.dialogs.alert(message);
      }
   }

   disconnectYouTube(error) {
      this.$uibModal.open({
         animation: true,
         templateUrl: 'campaign-disconnect-youtube-modal.html',
         controller: CampaignDisconnectYouTubeController,
         controllerAs: 'ctrl',
         resolve: {
            hasError: () => error === true
         }
      }).result.then(result => {
         this.campaignsApi.disconnectYouTube(this.model.id);
         this.model.settings.youTubeRefreshToken = '';
      });
   }

   connectYouTube() {
      // let redirectURL = `~/api/youtube/campaign/${this.model.id}/authorize?access_token=${this.localStorageService.get('auth.token')}`;
      let redirectURL = `//${this.session.apiDomain()}/api/youtube/campaign/${this.model.id}/authorize?access_token=${this.localStorageService.get('auth.token')}`;
      this.campaignsApi.list(this.brand.id).then((campaigns:any[]) => {
         let campaignsWithToken = _.filter(campaigns, c => c.settings.youTubeRefreshToken);

         if (campaignsWithToken.length === 0) {
            this.authorizeYouTube(redirectURL);
            return;
         }

         this.$uibModal.open({
            animation: true,
            templateUrl: 'campaign-connect-youtube-modal.html',
            controller: CampaignConnectYouTubeController,
            controllerAs: 'ctrl',
            resolve: {
               campaigns: () => campaignsWithToken,
               redirectURL: () => redirectURL,
               authorizeYouTube: () => () => this.authorizeYouTube(redirectURL)
            }
         }).result.then(result => {
            this.campaignsApi.copyYouTube(result.id, this.model.id);
            this.model.settings.youTubeRefreshToken = result.settings.youTubeRefreshToken;
         });
      });
   }
}

ng.module('e360')
   .controller('CampaignEditController', CampaignEditController);

class CampaignDisconnectYouTubeController {
   static $inject = ['$uibModalInstance', 'hasError'];

   constructor(
      private $uibModalInstance:uib.IModalInstanceService,
      public hasError:boolean
   ) { }

   disconnect() {
      this.$uibModalInstance.close();
   }

   close() {
      this.$uibModalInstance.dismiss();
   }
}

class CampaignConnectYouTubeController {
   static $inject = ['$uibModalInstance', 'campaigns', 'authorizeYouTube'];

   constructor(
      private $uibModalInstance:uib.IModalInstanceService,
      public campaigns:any[],
      private authorizeYouTube:Function
   ) {
      this.campaign = campaigns[0];
   }

   campaign;

   close() {
      this.$uibModalInstance.dismiss();
   }

   copy() {
      this.$uibModalInstance.close(this.campaign);
   }

   create() {
      this.authorizeYouTube();
   }
}
